import scrollMonitor from 'scrollmonitor';
import { breakpoints } from '../../scripts/globals';
import classnameToggle from './../../scripts/classname-toggle';

const components = [].slice.call(document.querySelectorAll('[data-component="careers-positions"]'));

components.forEach((component) => {
  const departmentLinks = [].slice.call(component.querySelectorAll('[data-careers-positions-link]'));
  const departmentCheckboxes = [].slice.call(component.querySelectorAll('[data-careers-positions-checkbox]'));

  const gallery = component.querySelector('[careers-search-gallery]');
  const watcher = scrollMonitor.create(component, { top: -140 });

  function visibilityChecker() {
    classnameToggle(gallery, 'is-sticky', watcher.isFullyInViewport);
    classnameToggle(gallery, 'is-top-positioned', watcher.isBelowViewport);
  }

  watcher.stateChange(visibilityChecker);
  visibilityChecker();

  function setCurrentItem(targetId) {
    departmentLinks.forEach((departmentLink) => {
      departmentLink.classList[departmentLink.dataset.for === targetId ? 'add' : 'remove']('careers-departments-list__link--active');
    });

    departmentCheckboxes.forEach((checkbox) => {
      const departmentTitle = checkbox.nextElementSibling;
      const departmentContent = departmentTitle.nextElementSibling;

      if (checkbox.id === `careers-department__checkbox--${targetId}`) {
        departmentTitle.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });

        setTimeout(() => {
          checkbox.checked = true; // eslint-disable-line no-param-reassign
          departmentContent.style.maxHeight = `${departmentContent.scrollHeight}px`;
        }, 200);

        setTimeout(() => {
          if (checkbox.checked) {
            departmentContent.style.maxHeight = 'none';
          }
        }, 600);
      } else {
        checkbox.checked = false; // eslint-disable-line no-param-reassign
        departmentContent.style.maxHeight = 0;
      }
    });
  }

  departmentLinks.forEach((link) => {
    link.addEventListener('click', (ev) => {
      setCurrentItem(ev.target.dataset.for);
    });
  });

  departmentCheckboxes.forEach((currentCheckbox) => {
    currentCheckbox.addEventListener('change', (ev) => {
      ev.preventDefault();

      if (ev.target.checked) {
        setCurrentItem(ev.target.dataset.id);
      } else {
        setCurrentItem();
      }
    });
  });

  if (window.location.hash) {
    setCurrentItem(window.location.hash.replace(/#/g, ''));
  } else if (window.innerWidth >= breakpoints.tablet && departmentLinks.length) {
    departmentLinks[0].click();
  }
});
